export const FETCH_APPROVAL_NOTIFICATIONS_REQUEST = "FETCH_APPROVAL_NOTIFICATIONS_REQUEST";
export const FETCH_APPROVAL_NOTIFICATIONS_SUCCESS = "FETCH_APPROVAL_NOTIFICATIONS_SUCCESS";
export const FETCH_APPROVAL_NOTIFICATIONS_FAILURE = "FETCH_APPROVAL_NOTIFICATIONS_FAILURE";


export const SET_APPROVAL_NOTIFICATION_COUNT = "SET_APPROVAL_NOTIFICATION_COUNT";
export const OPEN_APPROVAL_NOTIFICATION_MODAL = "OPEN_APPROVAL_NOTIFICATION_MODAL";
export const CLOSE_APPROVAL_NOTIFICATION_MODAL = "CLOSE_APPROVAL_NOTIFICATION_MODAL";